// extracted by mini-css-extract-plugin
export default {"button":"Button_button__dEjRE","button__decoration":"Button_button__decoration__TTIbq"};